import { relativeDay } from '../lab/labGeometry'

/** "6 Oct 2026": the month is spelled out so day and month never swap places by locale. */
export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

/** "5 days ago", "today" — or "Never" for something that has not happened. */
export function sinceLabel(iso: string | null): string {
  if (!iso) return 'Never'
  return relativeDay((new Date(iso).getTime() - Date.now()) / 86_400_000)
}
